/** @format */
import React from 'react';
import { createRoot } from 'react-dom/client';
import Social from './social';

/**
 * Build Social Share links.
 */
export const social = (): void => {
  const socialShare = document.getElementById('social-share');
  const socialShareProps = {
    follow: false,
  };
  if (socialShare) {
    const root = createRoot(socialShare);
    root.render(React.createElement(Social, socialShareProps, null));
  }
};
